import { fcmforWebConstant } from "../../../constants";
import { axiosInstance } from "../../../utils/axios";
import { requestHandler } from "../Store";

export const signInLocal = async (user) => {
  try {
    let result = await axiosInstance.post(`users/signIn`, {
      firebase_id: user.uid,
      email: user.email,
      photoUrl: user.photoUrl,
      deviceId: fcmforWebConstant(),
      userToken: user.accessToken,
      phoneNo: user.phoneNo,
      firstName: user.first_name,
      lastName: user.last_name,
      isWhiteLabel: user.isWhiteLabel,
      storeId: user.storeId,
    });
    if (!result) {
      return {
        success: false,
        message: "Something went wrong",
      };
    }
    return {
      success: true,
      data: result.data,
    };
  } catch (exception) {
    console.error(exception);
    return {
      success: false,
      message: exception.message,
    };
  }
};
export const signOut = (token, data) => {
  return requestHandler({
    method: "PUT",
    url: "users/signOut",
    token,
    data,
  });
};

export const getUserDashboard = async ({ store_id, token, user_id }) => {
  const url = `users/${user_id}/store/${store_id}/dashboard`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await axiosInstance.get(url, config);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    console.error(error);
    let errorMessage = "Something went wrong";
    if (error.response) {
      errorMessage = error.response.data;
    } else if (error.request) {
      errorMessage = "No response received";
    } else {
      errorMessage = error.message || "Error setting up the request";
    }
    return {
      success: false,
      message: errorMessage,
    };
  }
};
export const checkUserExistsApi = (
  token,
  phoneNo,
  isWhiteLabel,
  storeId,
  email = null
) => {
  return requestHandler({
    method: "GET",
    url: `users/check?phoneNo=${phoneNo}&isWhiteLabel=${isWhiteLabel}&storeId=${
      !isWhiteLabel ? null : storeId
    }&email=${email}`,
    token,
  });
};
